module.exports = __webpack_public_path__ + "image/title-icon.png";